import { useParams } from 'react-router-dom';
import { GroupView } from '@/views/GroupView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const GroupPage = () => {
  const { courseId, intakeId, groupNumber } = useParams<{ courseId: string; intakeId: string; groupNumber: string }>();

  if (!courseId || !intakeId || !groupNumber) {
    return null;
  }

  return (
    <MainLayout headerTitle="Group Detail">
      <GroupView
        courseId={Number(courseId)}
        intakeId={Number(intakeId)}
        groupNumber={Number(groupNumber)}
      />
    </MainLayout>
  );
};

export default GroupPage;

